export default function imageLoader({
  src,
}: {
  src: string;
  width: number;
  quality?: number;
}) {
  // For local images (starting with /), return as-is since they're already optimized
  if (src.startsWith("/")) {
    return src;
  }

  // For external images, you can use a service like Cloudinary, ImageKit, or similar
  // Example with Cloudinary (replace 'your-cloud-name' with actual cloud name):
  // return `https://res.cloudinary.com/your-cloud-name/image/fetch/w_${width},q_${quality || 75}/${encodeURIComponent(src)}`;

  // For now, return the original src for external images
  // You can integrate with image optimization services later
  return src;
}
